const palette = {
  primary: {
    main: '#051D40', // --primary_color
  },
  secondary: {
    main: '#2183c4', // --light_blue_color
  },
  common: {
    white: '#FFFFFF',
    black: '#000000',
  },
  custom: {
    orange: '#ed5f1e', // Custom orange color
    grey: '#686868 ',
  },
  snackbar: {
    color: {
      info: '#003764',
      success: '#355016',
      warning: '#754b00',
      error: '#5a0c0c',
    },
    background: {
      info: '#e9f3fb',
      success: '#f8fcf3',
      warning: '#fff9ee',
      error: '#fbe9e9',
    },
    icon: {
      info: '#1d7fd0',
      success: '#b3dd83',
      warning: '#ffbf4d',
      error: '#d01d1d',
    },
    boxShadowColor: 'rgba(53, 80, 22, 0.12)',
  },
};

export default palette;
